"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyApi = exports.TaxonomyTypeEnum = exports.TAXONOMY_API_ERROR = exports.TAXONOMY_POSTFIX = void 0;
const app_1 = require("app");
exports.TAXONOMY_POSTFIX = 'Taxonomy';
exports.TAXONOMY_API_ERROR = 'TAXONOMY_API_ERROR';
var TaxonomyTypeEnum;
(function (TaxonomyTypeEnum) {
    TaxonomyTypeEnum["ProductsTaxonomy"] = "productsTaxonomy";
    TaxonomyTypeEnum["NewsCategoriesTaxonomy"] = "newsCategoriesTaxonomy";
    TaxonomyTypeEnum["EventCategoriesTaxonomy"] = "eventCategoriesTaxonomy";
    TaxonomyTypeEnum["MarketsTaxonomy"] = "marketsTaxonomy";
    TaxonomyTypeEnum["DownloadTypeTaxonomy"] = "downloadTypeTaxonomy";
    TaxonomyTypeEnum["SegmentsTaxonomy"] = "segmentsTaxonomy";
    TaxonomyTypeEnum["SubSegmentsTaxonomy"] = "subSegmentsTaxonomy";
    TaxonomyTypeEnum["SolutionsTaxonomy"] = "solutionsTaxonomy";
    TaxonomyTypeEnum["ApplicationsTaxonomy"] = "applicationsTaxonomy";
    TaxonomyTypeEnum["BrandsDhstaxonomy"] = "brandsDHSTaxonomy";
    TaxonomyTypeEnum["BrandsDdstaxonomy"] = "brandsDDSTaxonomy";
    TaxonomyTypeEnum["ProductTypesDdstaxonomy"] = "productTypesDDSTaxonomy";
    TaxonomyTypeEnum["EnclosuresDdstaxonomy"] = "enclosuresDDSTaxonomy";
    TaxonomyTypeEnum["CareersTaxonomy"] = "careersTaxonomy";
    TaxonomyTypeEnum["CountriesTaxonomy"] = "countriesTaxonomy";
    TaxonomyTypeEnum["MegatrendsTaxonomy"] = "megatrends";
    TaxonomyTypeEnum["LanguagesTaxonomy"] = "languagesTaxonomy";
})(TaxonomyTypeEnum || (exports.TaxonomyTypeEnum = TaxonomyTypeEnum = {}));
class TaxonomyApi extends app_1.BaseApi {
    // Override from BaseApi
    throwException(message, responseData, _name = '') {
        super.throwException(message, responseData, exports.TAXONOMY_API_ERROR);
    }
    updateStorage(data) {
        this.setDataToStorage(data, null);
    }
}
exports.TaxonomyApi = TaxonomyApi;
